module.exports = __webpack_public_path__ + "img/expedisimotor.7109fee5.png";